import { showToast, TOAST_KEY } from 'components/ToastNotification';
import { notification } from 'antd';
import React from 'react';
import translations from 'translations';
import history from 'utils/history';
import utilMessages from 'utils/messages';

export const showFavoriteToast = (wasFavorite: boolean): void => {
  if (wasFavorite) {
    showToast({ message: translations(utilMessages.removedFromFavorite) });
    return;
  }

  showToast({
    message: (
      <>
        {`${translations(utilMessages.savedToFavorite)} `}
        <a
          href="/favorite"
          style={{ color: '#3c9041', textDecoration: 'none', fontWeight: 500 }}
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            notification.destroy(TOAST_KEY);
            history.push('/favorite');
          }}
        >
          {translations(utilMessages.viewFavorites)}
        </a>
      </>
    ),
  });
};
